var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-bot-response", class: { empty: !_vm.defaultFileUrl } },
    [
      !_vm.defaultFileUrl && !_vm.selectedFile
        ? _c(
            "div",
            { staticClass: "placeholder", on: { click: _vm.openSelectFile } },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(" attach_file "),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("chatbotv2.dragAndDropBrowseFile"))),
              ]),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "placeholder-wrapper position-relative",
              on: {
                mouseover: function ($event) {
                  _vm.hovered = true
                },
                mouseleave: function ($event) {
                  _vm.hovered = false
                },
              },
            },
            [
              _vm.defaultFileUrl && !_vm.uploading
                ? _c(
                    "span",
                    {
                      staticClass: "preview",
                      attrs: { src: _vm.defaultFileUrl },
                    },
                    [
                      _c("div", { staticClass: "media-content-wrapper" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.defaultFileUrl,
                              download: "",
                              target: "_blank",
                            },
                          },
                          [
                            _vm.getFile(_vm.defaultFileUrl)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "fi",
                                    class:
                                      "fi-" + _vm.getFile(_vm.defaultFileUrl),
                                  },
                                  [
                                    _c("div", { staticClass: "fi-content" }, [
                                      _vm._v(
                                        _vm._s(_vm.getFile(_vm.defaultFileUrl))
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("p", { staticClass: "media-content-text" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.download")) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm.selectedFileSrc
                ? _c(
                    "span",
                    {
                      staticClass: "preview",
                      attrs: { src: _vm.selectedFileSrc },
                    },
                    [
                      _c("div", { staticClass: "media-content-wrapper" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.selectedFileSrc,
                              download: "",
                              target: "_blank",
                            },
                          },
                          [
                            _vm.getFile(_vm.selectedFileSrc)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "fi",
                                    class:
                                      "fi-" + _vm.getFile(_vm.selectedFileSrc),
                                  },
                                  [
                                    _c("div", { staticClass: "fi-content" }, [
                                      _vm._v(
                                        _vm._s(_vm.getFile(_vm.selectedFileSrc))
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("p", { staticClass: "media-content-text" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.download")) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.uploading
                ? _c(
                    "div",
                    { staticClass: "uploading-banner" },
                    [
                      _c("a-progress", {
                        attrs: {
                          type: "circle",
                          "stroke-color": {
                            "0%": "#108ee9",
                            "100%": "#87d068",
                          },
                          percent: _vm.uploadProgress,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("chatbotv2.fileUploading")) + " ..."
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.defaultFileUrl && !_vm.uploading && _vm.hovered
                ? _c(
                    "div",
                    {
                      staticClass: "update-banner",
                      on: { click: _vm.openSelectFile },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" attach_file "),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("chatbotv2.clickToChooseNewFile"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("chatbotv2.or")) + "\n                "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "remove",
                            on: { click: _vm.removeFile },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.removeTheExistingOne"))
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }